import { Observable } from "./events";
export class ValidableBase {
    constructor() {
        this._valid = true;
    }
    get isValid() {
        return this._valid;
    }
    get validationObservable() {
        if (!this._validationObservable) {
            this._validationObservable = new Observable();
        }
        return this._validationObservable;
    }
    invalidate() {
        if (this.isValid) {
            this._doInvalidateInternal();
        }
    }
    validate(force) {
        if (!this.isValid || force) {
            this._doValidateInternal();
        }
    }
    revalidate() {
        this.invalidate();
        this.validate();
    }
    _doInvalidateInternal() {
        this._beforeInvalidate();
        this._valid = false;
        this._doInvalidate();
        if (this._validationObservable && this._validationObservable.hasObservers()) {
            this._validationObservable.notifyObservers(false, -1, this, this);
        }
        this._afterInvalidate();
    }
    _doValidateInternal() {
        this._beforeValidate();
        this._valid = true;
        this._doValidate();
        if (this._validationObservable && this._validationObservable.hasObservers()) {
            this._validationObservable.notifyObservers(true, -1, this, this);
        }
        this._afterValidate();
    }
    dispose() {
        this._validationObservable?.clear();
    }
    _beforeInvalidate() {
    }
    _doInvalidate() {
    }
    _afterInvalidate() {
    }
    _beforeValidate() {
    }
    _doValidate() {
    }
    _afterValidate() {
    }
}
ValidableBase.VALID_PROPERTY_NAME = "valid";
//# sourceMappingURL=validable.js.map